import { FC } from "react";
import { UserT } from "../../../../models/models";
import { useAuth } from "../../../../utils/hooks/useAuth";
import UserItem from "../UserItem/UserItem";
import Button, { ButtonModeE } from "../../../Button/Button";
import usePopup from "../../../../utils/hooks/usePopup";
import { H1, P } from "../../../Text/Text";
import LoginForm from "../../../../pages/Login/components/LoginForm/LoginForm";
import useAccount from "../../../../utils/hooks/useAccount";

import styles from "./profileDropdown.module.scss";

type ProfileDropdownPropTypes = {
  currentUser: UserT;
  onClose: () => void;
};

const ProfileDropdown: FC<ProfileDropdownPropTypes> = ({
  currentUser,
  onClose,
}) => {
  const { loggedUsers } = useAuth();
  const { createPopup, removePopup } = usePopup();
  const { logoutFromAccount } = useAccount();

  const handleAddAccount = () => {
    onClose && onClose();
    createPopup({
      body: <LoginForm isAddAccount />,
      className: styles.popupWrapper,
    });
  };

  const handleLogout = () => {
    const handleApproveLogout = () => {
      logoutFromAccount();
    };

    createPopup({
      header: <H1>Log out</H1>,
      body: (
        <P className={styles.logoutMessage}>Do you really want to log out?</P>
      ),
      footer: (
        <div className={styles.popupFooter}>
          <Button onClick={removePopup} mode={ButtonModeE.OUTLINED}>
            Cancel
          </Button>
          <Button onClick={handleApproveLogout}>Yes, log-out</Button>
        </div>
      ),
      className: styles.popupWrapper,
    });
  };

  return (
    <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
      <UserItem user={currentUser} isCurrent onClose={onClose} />
      <div className={styles.loggedUserList}>
        {loggedUsers
          ?.filter(({ userId }) => userId !== currentUser.userId)
          // remove duplicates by userId
          .filter(
            (user, index, self) =>
              index === self.findIndex((t) => t.userId === user.userId)
          )
          .map((user) => (
            <UserItem
              user={user}
              key={user.id}
              profilePhotoSrc={user.profilePhoto}
              onClose={onClose}
            />
          ))}
      </div>
      <div className={styles.footerButtons}>
        <Button
          icon="addCircle"
          mode={ButtonModeE.LINK}
          className={styles.addAccountButton}
          onClick={handleAddAccount}
        >
          Add account
        </Button>
        <Button icon="logout" mode={ButtonModeE.LINK} onClick={handleLogout}>
          Log out
        </Button>
      </div>
    </div>
  );
};

export default ProfileDropdown;
